var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_compare") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "40_All-Players",
    transform: "translate(-1348, -249)",
    fill: "#CFDAE6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(280, 226)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)",
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_compare",
    transform: "translate(1067, 22.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7145204,8.11802326 C10.8828545,7.95668386 11.157831,7.96107908 11.3263146,8.12839239 C11.4946185,8.29552729 11.4969894,8.56486845 11.330439,8.73609152 L9.60178995,10.4526452 L9.05481481,10.9945853 L15.56099,10.99473 C15.7764305,10.99473 15.9557378,11.148108 15.9929241,11.3504983 L16,11.4284883 C16,11.6681276 15.8033606,11.8622465 15.56099,11.8622465 L9.05481481,11.8617458 L9.60178995,12.4043314 L11.336757,14.1272696 C11.4980028,14.2931787 11.4935697,14.5624908 11.3263146,14.7285842 C11.1567885,14.8969328 10.8817834,14.8992923 10.7080946,14.7326826 L7.68886047,11.734331 C7.51855804,11.5651603 7.51857589,11.2917985 7.6889156,11.1225908 L10.7145204,8.11802326 Z M4.94768708,0.000397011888 C5.07197455,-0.0048580828 5.19432325,0.0422179124 5.28164985,0.132022893 L8.31113953,3.14055879 C8.48144196,3.30972942 8.48142411,3.58309127 8.3110844,3.75229892 L5.2879071,6.75445788 C5.17334496,6.872135 5.00981315,6.91884086 4.85462488,6.87850251 C4.70123064,6.83863047 4.58147151,6.72007931 4.54147274,6.56832777 C4.50163016,6.41716875 4.54712958,6.25655252 4.65930546,6.14898256 L6.39821005,4.42224457 L6.94419753,3.87952359 L0.439009983,3.88015973 C0.223569458,3.88015973 0.0442622256,3.72678178 0.00707593335,3.52439146 L0,3.44640148 C0,3.20676219 0.196639393,3.01264322 0.439009983,3.01264322 L6.94419753,3.0123631 L6.39821005,2.47055838 L4.66566847,0.750030875 C4.54804053,0.637100866 4.50131489,0.476830316 4.54147274,0.324475182 C4.58147151,0.172723636 4.70123064,0.0541724805 4.86489046,0.0122062599 L4.85432099,0.0158198875 L4.86123457,0.0138445788 L4.93726869,0.00140246269 L4.94768708,0.000397011888 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompare);
export default __webpack_public_path__ + "static/media/ic_compare.ecdcf739bf42df2ce9a180c9276da0bf.svg";
export { ForwardRef as ReactComponent };